module.exports = __webpack_public_path__ + "img/la_testjig.66b9fa0d.jpg";